import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Request {
  id: number;
  customer_name: string;
  phone_number: string;
  location: string;
  location_details?: string;
  language?: string;
  status: 'waiting' | 'responded' | 'completed' | 'cancelled' | 'rejected' | 'timeout' | 'timeout_out_of_hours' | 'auto_responded';
  response_time?: number;
  response_sent_at?: string;
  created_at: string;
  updated_at: string;
  session_id?: string; // Web chatbot için UUID, WhatsApp için telefon numarası
}

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getWaitingRequests(): Observable<Request[]> {
    return this.http.get<Request[]>(`${this.apiUrl}/requests/waiting`);
  }

  getAllRequests(): Observable<Request[]> {
    return this.http.get<Request[]>(`${this.apiUrl}/requests`);
  }

  getRequestById(id: number): Observable<Request> {
    return this.http.get<Request>(`${this.apiUrl}/requests/${id}`);
  }

  sendQuickResponse(id: number, minutes: number, phoneNumber?: string): Observable<any> {
    const body: any = { response_time: minutes };
    if (phoneNumber) {
      body.phone_number = phoneNumber;
    }
    return this.http.post(`${this.apiUrl}/requests/${id}/respond`, body);
  }

  updateRequestStatus(id: number, status: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/requests/${id}/status`, { status });
  }

  getHistory(): Observable<Request[]> {
    return this.http.get<Request[]>(`${this.apiUrl}/requests/history/all`);
  }
}



